<caremoni-dialog-template id="ttl-setting" class="hrhr" [dialogTemplate]="dialogTemplate" >
    <div modal-body>
        <div class="dialog-container">
            <div class="dialog-body">
                <div class="button-row action-btn bp-2">
                    <div class="d-flex">
                    <p class="instruction"><span>ケアモニの</span><strong>{{ instruction || "" }}</strong><span>に表示する記録を選択してください。</span></p>
                        <div class="button-row">
                            <button class="btn-secondary m-a" (click)="setDefaultByColName()">初期の設定に戻す</button>
                        </div>
                    </div>
                    <p class="f-1"></p>
                    <div style="margin-top: 10px;">
                        <a class="btn-text" (click)="showDialogCancel()">キャンセル</a>
                        <button class="btn-primary" (click)="saveCondition()">保存</button>
                    </div>
                </div>
                <div class="d-flex py-1">
                    <div class="fw-b">
                        <span>①表示するタイトルを指定します</span>
                        <a class="a-btn" (click)="onShowTagDialog()" >タグ情報とは？</a>
                    </div>
                    <div class="m-a"></div>
                    <div class="d-flex">
                        <strong>②表示するタイトル部品を指定します</strong>
                        <label class="condition-label">
                            <caremoni-checkbox [value]="itagChecked" (onClick)="isShowTagLst($event)"></caremoni-checkbox>
                            記録があれば連携
                        </label>
                        <div class="px-1"><div class="title-chip" pTooltip="{{toolTip.TT_13}}" tooltipPosition="top">?</div></div>
                    </div>
                </div>
                <div class="tables-container">
                    <!-- kbn Table -->
                    <div class="table-box w-20">
                        <div class="w-100 f-col">
                            <div class="f-1">
                                <div class="table-title">#タイトル区分タグ情報</div>
                                <div class="table-row" *ngFor="let kbnTagItem of kbnTagLst" [ngClass]="kbnTagItem.selected" 
                                    (click)="selectKbnTag(kbnTagItem)"> {{kbnTagItem.kbnTag}}</div>
                            </div>
                            <div class="pt-1 t-c">
                                <button class="btn-accent" (click)="showKbnTagLst()">他のタイトル区分を追加</button>
                            </div>
                        </div>
                    </div>
                    <!-- Ttl Table -->
                    <div class="table-box w-40">
                        <div class="w-50">
                            <div class="table-title">#タイトルタグ情報</div>
                            <div class="table-row" *ngFor="let ttlTagItem of ttlTagLst" [ngClass]="ttlTagItem.selected" 
                                (click)="selectTtlTag(ttlTagItem)"> {{ttlTagItem.ttlTag}}</div>
                        </div>
                        <div class="w-50">
                            <div class="table-title d-flex">
                                <div class="d-flex m-a">
                                    タイトルプレビュー
                                    <div class="px-1 pt-1"><div class="title-chip" pTooltip="{{toolTip.TT_14}}" tooltipPosition="right">?</div></div>
                                </div>
                            </div>
                            <div class="table-row table-row-disable" *ngFor="let ttlNameItem of ttlNameLst" [ngClass]="ttlNameItem.selected" 
                                (click)="selectTtlName(ttlNameItem)"> {{ttlNameItem.ttlName}}</div>
                        </div>
                    </div>
                    <!-- Itag Table -->
                     <div class="w-40 table-box">
                        <div *ngIf="!itagChecked" class="d-flex w-100">
                            <div class="w-50">
                                <div class="table-title">#項目タグ情報</div>
                                <div class="table-row" *ngFor="let iTagItem of iTagLst" [ngClass]="iTagItem.selected" 
                                    (click)="selectItag(iTagItem)"> {{iTagItem.iTag}}</div>
                            </div>
                            <div class="w-50">
                                <div class="table-title d-flex">
                                    <div class="d-flex m-a">
                                         部品プレビュー
                                        <div class="px-1 pt-1"><div class="title-chip" pTooltip="{{toolTip.TT_15}}" tooltipPosition="right">?</div></div>
                                    </div>
                                </div>
                                <div class="table-row table-row-disable" *ngFor="let iTagNameItem of iTagNameLst" [ngClass]="iTagNameItem.selected" 
                                    (click)="secletItagName(iTagNameItem)"> {{iTagNameItem.iTagName}}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Selected Tag -->
                <div class="p-1"></div>
                <div class="selected-tag-section">
                    <div class="tag-btn button-row">
                        <p class="fw-b">③タイトル情報を追加します</p>
                        <button class="btn-primary" (click)="pickTag()">追加</button>
                    </div>
                    <div class="d-flex p-1">
                        <h3>【選択したタグ】</h3>
                        <div class="px-1"><div class="title-chip" pTooltip="{{toolTip.TT_16}}" tooltipPosition="right">?</div></div>
                    </div>
                    <div class="tag-box">
                        <div *ngFor="let tag of listTags" class="tag-chip">
                            {{tag.kbnTtlTag}}.{{tag?.iTag?.replace("#","") ?? ""}}
                            <button class="chip-remove" (click)="removeTag(tag)">×</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</caremoni-dialog-template>

<p-dialog [(visible)]="isShowKbnTagLst" [modal]="true" [breakpoints]="{ '1199px': '75vw', '600px': '90vw' }" class="dialog-header-none"
    [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false" [showHeader]="false" [closable]="false">
    <div class="bgr-black p-2">
        <div class="p-2 fw-b">タイトル区分の追加</div>
        <div class="d-flex p-2">
            <div class="w-45">
                <div class="table-title-text">選択可能</div>
                <div class="title-dial">
                #タイトル区分タグ情報
                </div>
                <div class="table-box" style="height: 386px;  overflow-y: auto;">
                    <div class="w-100">
                        <div class="table-row c-gray" *ngFor="let kbnTagItem of kbnTagLstAll" [ngClass]="kbnTagItem.kbnselected" 
                            (click)="selectKbnTagLst(kbnTagItem)"> {{kbnTagItem.kbnTag}}</div>
                    </div>
                </div>
            </div>
            <div class="w-10"></div>
            <div class="w-45">
                <div class="table-title-text">選択済み</div>
                <div class="title-dial">#タイトル区分タグ情報</div>
                <div class="table-box"  style="height: 386px;  overflow-y: auto;">
                    <div class="w-100">
                        <div class="table-row d-flex" *ngFor="let kbnTagSelectedItem of kbnTagAllSelected">
                            <span class="f-1">{{kbnTagSelectedItem.kbnTag}}</span>
                            <button class="chip-remove" (click)="removeKbnTagLst(kbnTagSelectedItem)">×</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="p-2"></div>
        <div class="t-end p-2 p-b-10">
            <a class="btn-text" (click)="closeKbnTagLst()">キャンセル</a>
            <span class="btn-primary btn-custom" (click)="aceptKbnTagLst()">保存</span>
        </div>
    </div>
</p-dialog>

<caremoni-tag-info-dialog
    *ngIf="showTagDialog"
    (onClosedHandler)="onClosedTagDialog()"
>
</caremoni-tag-info-dialog>